import { fieldTypeOf, settingsOf } from '../field-types';
import type { FieldElement } from '../format/form-definition';
import { PHONE_PATTERN } from '../format/pieces';
import { USER_PLACEHOLDERS } from '../texts/userPlaceholders';
import { isIsoDate } from 'framework/utils/hooks/useDateService';
import { messageOr } from './message';
import { BuiltInCheck } from '../field-types/card';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PASSES: { [C in BuiltInCheck]: (value: unknown) => boolean } = {
  emailFormat: value => typeof value === 'string' && EMAIL.test(value.trim()),
  phoneFormat: value => typeof value === 'string' && PHONE_PATTERN.test(value.trim()),
  realDate: value => typeof value === 'string' && isIsoDate(value),
  number: value => typeof value === 'number' && Number.isFinite(value),
  wholeNumber: value => typeof value === 'number' && Number.isInteger(value),
};

const checkOf = (field: FieldElement): BuiltInCheck | undefined => {
  return fieldTypeOf(field).builtInCheck?.(field.settings);
};

export const builtInCheckText = (field: FieldElement): string | undefined => {
  const check = checkOf(field);
  return check && USER_PLACEHOLDERS.builtIn[check];
};

export const builtInCheckError = (field: FieldElement, value: unknown): string | undefined => {
  const check = checkOf(field);
  if (!check || PASSES[check](value)) return undefined;
  return messageOr(formatMessageOf(field), USER_PLACEHOLDERS.builtIn[check]);
};

const formatMessageOf = (field: FieldElement): string | undefined => {
  const { formatMessage } = settingsOf(field);
  return typeof formatMessage === 'string' ? formatMessage : undefined;
};
